import dayjs, { ConfigType } from "dayjs"
import { ISODate } from "../units/types/ISODate"

export const formatISODate = (date?: ConfigType): ISODate | undefined => {
  if (!date) return undefined

  return dayjs(date).format("YYYY-MM-DD") as ISODate
}
